module.exports = __webpack_public_path__ + "static/media/how-rewards-work-step-5.9cd1da06.jpg";